// extracted by mini-css-extract-plugin
export default {"firstHeader":"src-pages-ProductEditor-SimpleProduct-Pricing-css__firstHeader--dkpid","fontbackHeader":"src-pages-ProductEditor-SimpleProduct-Pricing-css__fontbackHeader--BfMvp"};